
export default (colors: any) => ({
  container: {
    minHeight: "100%",
    width: "100%",
    backgroundColor: colors.common.background
  }
})
